import { Box } from "@/components/layout/flexbox";
import { GuestsList as GuestsList } from "@/components/pieces/coaching/meetings/MeetingGuests/components/GuestsList";
import { ManageGuestsSection } from "@/components/pieces/coaching/meetings/MeetingGuests/components/GuestsManageSection";
import { SUBTEXT_COLOR } from "@/css/constants";
import { FullMeeting } from "@/types/meetings";
import { ensureNonNullArray } from "@/utils/array";

export function MeetingGuests({ meeting }: { meeting: FullMeeting }) {
  const guests = ensureNonNullArray(meeting.guests);
  const limit = 4;

  return (
    <Box pt={24} mt={24} className="bts">
      <Box fontWeight={500}>Guests</Box>

      <Box mt={2}>
        {meeting.allowGuests ? (
          <GuestsList guests={guests} total={guests.length} limit={limit} />
        ) : (
          <Box fontStyle="italic" color={SUBTEXT_COLOR}>
            Disabled on this session
          </Box>
        )}
      </Box>

      <ManageGuestsSection meeting={meeting} />
    </Box>
  );
}
